import { ACCIDENT_MODAL_OPEN, ACCIDENT_MODAL_CLOSE } from './actions'

const initialState = {
  show: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCIDENT_MODAL_OPEN:
      return {
        ...state,
        show: true
      }
    case ACCIDENT_MODAL_CLOSE:
      return {
        ...state,
        show: false
      }
  }
  return {
    ...state
  }
}

export default reducer
